<template>
	<div>
		<div
			class="tw-border-l-[3px] tw-cursor-pointer tw-border-[#F38B00] tw-w-full tw-h-full md:tw-h-[72px] tw-bg-[#fff2e3] tw-mb-8 tw-rounded-[4px] tw-p-4 tw-flex tw-gap-x-2"
			v-if="!bvn && country === 'NG'"
			@click="showBvnForm = true"
		>
			<img src="@/assets/img/shield.svg" alt="shield icon" />
			<div class="tw-tracking-[0.16px] tw-mr-auto">
				<p class="tw-text-secondary !tw-font-CircularStd-medium tw-text-[15px]">
					Safeguard Your Account
				</p>
				<p class="tw-text-[13px] tw-text-[#323e67]">
					Add your BVN for a safer experience
				</p>
			</div>
			<img
				src="@/assets/img/arrow-forward.svg"
				alt="proceed icon"
				class="tw-h-6 tw-w-6"
			/>
		</div>
		<SideModal v-if="showBvnForm" title="Bank verification Number" @goBack="$emit('close-modal')" @close="handleClose">
			<template #content>
				<div class="tw-pt-4 tw-max-w-[350px] tw-mx-auto">
					<p class="tw-text-gray-lightest3 tw-leading-[22.5px] tw-text-[15px]">
						We use your bank verification number to ensure your account belongs
						to you.
					</p>
					<form @submit.prevent="addUserBvn" class="tw-mt-6">
						<label
							for="bvn"
							class="tw-text-secondary tw-block !tw-font-CircularStd-medium tw-text-sm tw-mb-1"
							>Bank Verification Number (11 digits)</label
						>
						<InputField
							name="bvn"
							:current-value="bvn"
							label="Enter your BVN"
							:validate="true"
							type="number"
							@input="setBvn"
						/>
						<div
							class="tw-w-full tw-cursor-pointer tw-mt-4 tw-bg-[#fff2e3] tw-rounded-[4px] tw-flex tw-justify-center tw-px-8 tw-py-2 tw-gap-x-2"
							:class="[showInfo ? '' : 'tw-mb-8 ']"
							@click="showInfo = !showInfo"
						>
							<img
								class="tw-w-5 tw-h-5"
								src="@/assets/img/orange-question-mark.svg"
								alt=""
							/>
							<p class="tw-text-sm tw-text-[#C06C00]">
								Why do we need this information?
							</p>
						</div>
						<div
							class="tw-w-full tw-py-[15px] tw-px-[25px] background-color tw-mt-[1px] tw-h-max tw-border tw-border-t-0 tw-border-[#fff2e3] tw-rounded-b-[4px]"
							v-if="showInfo"
						>
							<p
								class="tw-text-xs tw-tracking-[-0.06px] tw-text-gray-lightest3"
							>
								Your bank verification number (BVN) is crucial for ensuring the
								security of your account. It helps us confirm your identity,
								preventing unauthorized access and protecting your finances.
							</p>
						</div>
						<BtnComponent
							title="Done"
							:loading="loading"
							:disabled="!BvnValue"
						/>
					</form>
				</div>
			</template>
		</SideModal>
		<SuccessModal
			:show="showSuccessModal"
			title="Congratulations! Your BVN has been successfully added.
"
			body="Your account is now more secure than ever. "
      @close="closeModal"
		/>
	</div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import BtnComponent from "../general/BtnComponent.vue";
import InputField from "../general/InputField.vue";
import SuccessModal from "../general/SuccessModal.vue";
import SideModal from "../general/sidemodal/SideModal.vue";

const store = useStore();
const emits = defineEmits(['refresh-data', 'close-modal'])
const props = defineProps({
	openForm: {
		type: Boolean,
		default: () => false
	}
})

const openForm = computed(() => props.openForm)

const showBvnForm = ref(false);
const BvnValue = ref("");

const showInfo = ref(false);
const loading = ref(false);
const showSuccessModal = ref(false);
const investorDetails = computed(() => store.getters["organisationModule/organisationDetails"]);
const bvn = computed(() => investorDetails.value.bvn)
const country = computed(() => investorDetails.value.country);

watch(
	openForm,
	(val) => {
		if (val) {
			showBvnForm.value = true;
		}
	})

const setBvn = ({ value }) => {
	BvnValue.value = value;
};

const addUserBvn = async () => {
	const payload = {
		bvn: String(BvnValue.value),
	};
	loading.value = true;
	try {
		await store.dispatch("organisationModule/addUserBvn", payload);
		showSuccessModal.value = true;
		showBvnForm.value = false;
		loading.value = false;
	} catch (error) {
		loading.value = false;
	}
};

const handleClose = () => {
	showBvnForm.value = false
	emits('close-modal')
}

const closeModal = () => {
  showSuccessModal.value = false;
  emits('refresh-data')
}

const closeForm = () => {
	emits('close-modal')
	showBvnForm.value = false
}
</script>

<style lang="scss" scoped>
.background-color {
	background-color: rgba(255, 238, 217, 0.3);
}
</style>
